import { createFromJS } from "../../../types";
import { definitionActionTypes } from "../";
import { toggleViewSettingsShowRelationshipTypes } from "../utils";
import { actionTypes } from "./actions";

const reducer = (state = createFromJS.NarrativeViewSettingsRecord({}), action) => {
  switch (action.type) {
    case actionTypes.SET_COLUMN_LEVEL:
      return state.set("columnLevel", action.columnLevel);
    case actionTypes.CHANGE_SHOW_IDENTIFIER:
      return state.set("showIdentifier", action.show);
    case actionTypes.CHANGE_SHOW_DATES:
      return state.set("showDates", action.show);
    case actionTypes.CHANGE_SHOW_DURATION:
      return state.set("showDuration", action.show);
    case actionTypes.CHANGE_SHOW_NARRATIVE:
      return state.set("showNarrative", action.show);
    case actionTypes.TOGGLE_SHOW_RELATIONSHIP_TYPES:
      return toggleViewSettingsShowRelationshipTypes(state, action.typeIds);
    case actionTypes.CHANGE_SHOW_BLOCKS:
      return state.set("showBlocks", action.show);
    case actionTypes.CHANGE_SHOW_BLOCKED_BY:
      return state.set("showBlockedBy", action.show);
    case actionTypes.CHANGE_SHOW_IMAGE:
      return state.set("showImage", action.show);
    case actionTypes.CHANGE_SHOW_SUMMARY:
      return state.set("showSummary", action.show);
    case actionTypes.CHANGE_SHOW_INFO_ICONS:
      return state.set("showInfoIcons", action.show);
    case definitionActionTypes.APPLY_VIEW_SETTINGS_TO_ALL_VIEWS:
      return state.merge(action.viewSettings);
    default:
      return state;
  }
};

export default reducer;
